import { NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { UserEventAction } from 'src/app/core/constants/user-event.constants';

import { InternalInnerHtmlDirective } from '../../../../shared/directives/internal-inner-html.directive';
import { BaseFormControlComponent } from '../../form-control/base-form-control.component';

@Component({
  selector: 'air-checkbox-control',
  templateUrl: './checkbox-control.component.html',
  imports: [ReactiveFormsModule, InternalInnerHtmlDirective, NgClass]
})
export class CheckboxControlComponent extends BaseFormControlComponent implements OnInit, OnDestroy {
  onChange(): void {
    this.pushUserEvent(UserEventAction.set, this.control.label, this.formControl?.value);
  }
}
